import { OrderLabel } from "api/types/order/order";

export enum ActionType {
  GET_ORDER_LABELS_SUCCESS = "GET_ORDER_LABELS_SUCCESS"
}

interface IGetOrderLabelsSuccess {
  type: ActionType.GET_ORDER_LABELS_SUCCESS,
  payload: OrderLabel[]
}

export type Action = IGetOrderLabelsSuccess;
